import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/ScrollTotop/ScrollTotop";

import Home from "./components/home/Home";
import Gallery from "./components/gallery/Gallery";
import About_us from "./components/about_us/About_us";
import ContactPage from "./components/contactPage/ContactPage";
import TermsOfUse from "./components/termsOfUse/TermsOfUse";
import PrivacyPolicy from "./components/privacyPolicy/PrivacyPolicy";
import EnvironmentalPolicy from "./components/environmentalPolicy/EnvironmentalPolicy";
import Canonical from "./components/seo/Canonical";


function App() {
  return (
    <>
      <ScrollToTop />
      <Canonical />

      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_us />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/environmental-policy" element={<EnvironmentalPolicy />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
